import type { PageBlockDefinition } from '../definition-types'

export const sectionDividerDefinition: PageBlockDefinition = {
  type: 'section-divider',
  label: 'Section Divider',
  description: 'A horizontal rule that visually separates sections. Optional labeled variant.',
  category: 'structural',
  rowCompatible: true,
  columnCompatible: true,
  minArticles: 0,
  maxArticles: 0,
  slots: [],
  defaultConfig: {
    style: 'plain',
    label: null,
  },
  editorFields: [
    {
      key: 'style',
      label: 'Style',
      type: 'select',
      options: [
        { label: 'Plain', value: 'plain' },
        { label: 'Thick', value: 'thick' },
        { label: 'Labeled', value: 'labeled' },
      ],
    },
    { key: 'label', label: 'Label Text', type: 'text' },
  ],
}
